// extracted by mini-css-extract-plugin
export default {"replies-section":"RepliesSection_replies-section__Dpx4n"};